import classNames from "classnames";
import AscTextInput from "../../AscInputFields/AscTextInput/AscTextInput";
import AscSelectInput from "../../AscInputFields/AscSelectInput/AscSelectInput";

import { TrashIcon } from "../../AscIcons";

import styles from "./AscSelectActivityQuestionAnswerForm.module.scss";
import { AscSelectActivityQuestionAnswerFormProps } from "./AscSelectActivityQuestionAnswerForm.types";

export default function AscSelectActivityQuestionAnswerForm<
  A extends string | number
>({
  className,
  selectOptions,
  value,
  onChange,
  onDelete,
  canDelete = false,
  answerLabel = "Answer",
  questionLabel = "Question",
  multiple = false,
  questionFieldDisabled = false,
  hideDelete = false,
}: AscSelectActivityQuestionAnswerFormProps<A>) {
  function handleChange(changedValue: {
    question?: string;
    answer?: string | number;
    answers?: (string | number)[];
  }) {
    onChange?.({
      question: changedValue?.question ?? value?.question,
      answer: changedValue?.answer ?? value?.answer,
      answers: changedValue?.answers ?? value?.answers,
    } as any); //TODO: fix type!
  }

  return (
    <div className={classNames(styles.ground, className)}>
      <div className={styles.form}>
        <div className={styles.formField}>
          <label className={styles.fieldLabel}>{questionLabel}</label>
          <div className={styles.inputField}>
            <AscTextInput
              disabled={questionFieldDisabled}
              fullWidth={true}
              className={styles.input}
              placeholder={`Enter ${questionLabel?.toLowerCase()}`}
              value={value?.question}
              onChange={(e) => handleChange({ question: e.target.value })}
            />
          </div>
        </div>

        <div className={classNames(styles.formField, styles.selectField)}>
          <label className={styles.fieldLabel}>{answerLabel}</label>
          <div className={styles.inputField}>
            <AscSelectInput
              className={styles.input}
              fullWidth={true}
              placeholder={`Select ${answerLabel?.toLowerCase()}`}
              disabled={selectOptions?.length === 0}
              {...(multiple
                ? {
                    multiple: true,
                    value: value?.answers,
                    onChange: (a) => handleChange?.({ answers: a }),
                  }
                : {
                    multiple: false,
                    value: value?.answer,
                    onChange: (a) => handleChange?.({ answer: a }),
                  })}
            >
              {selectOptions?.map(({ name, value, disabled }) => (
                <AscSelectInput.Option
                  key={`${value}`}
                  value={value}
                  label={name}
                  disabled={disabled}
                />
              ))}
            </AscSelectInput>

            <hr
              className={classNames(styles.hR, {
                [styles.hRHide]: hideDelete,
              })}
            />

            <TrashIcon
              onClick={canDelete ? onDelete : undefined}
              className={classNames(styles.trashIcon, {
                [styles.iconDisabled]: !canDelete,
                [styles.iconHidden]: hideDelete,
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
